<template>
  <el-table
    class="project-list"
    :data="list"
    size="mini"
    height="18rem"
    stripe
    :class="{ 'dark': skinType }"
    style="border-radius: 4px; color: #969191"
    :header-cell-class-name="skinType?'':'bg-gray'"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column prop="ProjectName" label="项目名称" min-width="100" align="center">
    </el-table-column>
    <el-table-column
      prop="RiongLiang"
      width="100"
      label="总容量(kVA)"
      align="center"
    ></el-table-column>
    <el-table-column prop="BianYaQi" label="变压器数量" width="80" align="center">
    </el-table-column>

    <el-table-column
      prop="ProjectArea"
      width="100"
      label="建筑面积(㎡)"
      align="center"
    >
    </el-table-column>
    <!-- <el-table-column label="大屏" width="60">
      <template slot-scope="scope" >
        <span  plain class="iconfont iconjinrushiyan cursor-pointer"
        @click="handleClick(scope.row)"></span>
      </template>
    </el-table-column> -->
  </el-table>
</template>
<script>
export default {
  name: 'project-list',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 点击事件
    handleClick(project) {
      window.open(project.F_ItemURL);
    },
    // 设置指定行、列、具体单元格颜色
    cellStyle({ columnIndex }) {
      if (columnIndex === 2) {
        return 'color:#4D9FFF'; // rgb(105,0,7)
      }
      return '';
    },

    // eslint-disable-next-line no-unused-vars
    renderHeader(createElement, { column, _self }) {
      // eslint-disable-next-line max-len
      console.log(createElement); //  function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
      const { label } = column;
      const labelArr = label.split(' ');
      return createElement(
        'span', // 创建最外层的标签可随意
        [
          createElement(
            'span',
            {
              // 创建第一个元素的标签可随意
              attrs: { type: 'text' },
            },
            [labelArr[0]],
          ),
          createElement(
            'p',
            {
              // 创建第二个元素的标签可随意
              attrs: { type: 'text', style: 'font-size:12px' }, // 给分割的某个元素单独加样式
            },
            [labelArr[1] || ''],
          ),
        ],
      );
    },
  },
};
</script>
<style lang="less" scoped >
.el-table .cell {
  text-align: center;
  white-space: pre-line; /*保留换行符*/
}
</style>
